import { Box, Heading, Text } from "src/components/UI";

const DirectDebitHeader = () => {
  return (
    <Box
      width="100%"
      marginBottom={["16px", "40px"]}
      alignItems={["unset", "center"]}
    >
      <Heading
        as="h1"
        fontFamily="Roboto, sans-serif"
        fontSize={["17px", "34px"]}
        fontWeight={["700", "700"]}
        lineHeight={["24px", "48px"]}
        letterSpacing={[null, "-0.32px"]}
        textAlign={["center", "center"]}
        color={["#404040", "#000000"]}
        padding={["16px", "unset"]}
        margin={[null, "64px 0 32px"]}
      >
        Praktis Dengan Fitur Bayar Otomatis
      </Heading>
      <Text
        fontFamily="Roboto, sans-serif"
        fontSize={["14px", "16px"]}
        fontWeight={["400", "400"]}
        lineHeight={["20px", "24px"]}
        letterSpacing={["0.16px", "unset"]}
        textAlign={["left", "center"]}
        maxWidth={["100%", "688px"]}
        color={["#404040", "#404040"]}
        padding={["0 16px", "unset"]}
      >
        Bayar Otomatis bikin kamu anti telat bayar cicilan. Dengan fitur ini,
        saldo rekeningmu di bank akan terpotong secara otomatis setiap bulan
        sehingga tagihan Home Credit kamu jadi bisa terbayar sesuai jadwal.
      </Text>
    </Box>
  );
};

export default DirectDebitHeader;
